import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import type { Resource } from 'i18next';

import { LOCALES_LIST } from '@/constants';

export function initI18n(resources: Resource = {}): void {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      supportedLngs: LOCALES_LIST,
      nonExplicitSupportedLngs: true,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });
}

export function transformLocales(
  ...locales: Array<Record<string, Record<string, string>> | undefined>
): Record<string, { translation: Record<string, string> }> {
  return LOCALES_LIST.reduce(
    function (res, lang) {
      const translations = locales.reduce(
        function (translation, locale = {}) {
          return { ...translation, ...locale[lang] };
        },
        {} as Record<string, string>,
      );
      return { ...res, [lang]: { translation: translations } };
    },
    {} as Record<string, { translation: Record<string, string> }>,
  );
}
